export const GET_ORDER_DETAILS_REQUEST = 'GET_ORDER_DETAILS_REQUEST';
export const GET_ORDER_DETAILS_SUCCESS = 'GET_ORDER_DETAILS_SUCCESS';
export const GET_ORDER_DETAILS_FAILURE = 'GET_ORDER_DETAILS_FAILURE';

export const GET_ORDER_DETAILS_STATUS_REQUEST = 'GET_ORDER_DETAILS_STATUS_REQUEST';
export const GET_ORDER_DETAILS_STATUS_SUCCES = 'GET_ORDER_DETAILS_STATUS_SUCCES';

export const SAVE_ORDER_REQUEST = 'SAVE_ORDER_REQUEST';
export const SAVE_ORDER_SUCCESS = 'SAVE_ORDER_SUCCESS';
export const SAVE_ORDER_FAILURE = 'SAVE_ORDER_FAILURE';

export const ADD_SUBORDER_REQUEST = 'ADD_SUBORDER_REQUEST';
export const ADD_SUBORDER_SUCCESS = 'ADD_SUBORDER_SUCCESS';
export const ADD_SUBORDER_FAILURE = 'ADD_SUBORDER_FAILURE';

export const GET_LINKED_PLANNINGS_REQUEST = 'GET_LINKED_PLANNINGS_REQUEST';
export const GET_LINKED_PLANNINGS_SUCCESS = 'GET_LINKED_PLANNINGS_SUCCESS';
export const GET_LINKED_PLANNINGS_FAILURE = 'GET_LINKED_PLANNINGS_FAILURE';

export const EXTERNAL_REMOVE = 'EXTERNAL_REMOVE';

export const PLANNING_UPDATE_ORDER_SOCKET_EVENTS = 'PLANNING_UPDATE_ORDER_SOCKET_EVENTS';
export const PLANNING_UPDATE_ORDER_SOCKET_EVENTS_SUCCESS =
    'PLANNING_UPDATE_ORDER_SOCKET_EVENTS_SUCCESS';
export const PLANNING_UPDATE_ORDER_SOCKET_EVENTS_FAILURE =
    'PLANNING_UPDATE_ORDER_SOCKET_EVENTS_FAILURE';

export const RESET_WIPCODES_CHANGED = 'RESET_WIPCODES_CHANGED'
